<script setup>
import BlogCategory from '@sections/blog/blog-category.vue'
import Hero from '@sections/blog/hero.vue'
import Delimiter from '@sections/delimiter.vue'
import { useNewsStore } from '@stores/news'

const news = useNewsStore()
</script>
<template>
	<template v-if="news.articles?.length > 0">
		<Hero :item="news.articles.slice(0, 1)[0]" />
		<BlogCategory />
		<Delimiter />
	</template>
</template>
